<template>
  <div class="authors">
    <template v-for="(author, index) in authors">
      <template v-if="authors.length > 1 && index > 0">
        <template v-if="(authors.length - index) === 1"> and </template>
        <template v-else>, </template>
      </template>
      <span>{{ author.name_first }}&nbsp;{{author.name_middle ? author.name_middle + ' ' : ''}}{{author.name_last}}</span>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'issue-authors',
    props: ['authors']
  }
</script>

<style lang="scss" scoped>
  .authors {
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    line-height: 1.21;
    text-align: left;
    color: $accent-color-2;
    margin-bottom: 36.5px;
    margin: 15px 0 0;
    span {
      text-decoration: underline;
    }
  }
</style>



// WEBPACK FOOTER //
// IssueAuthorsComponent.vue?9ed9d3b6